import React, {useState, useEffect,useRef, } from 'react';
import * as Actions from '../../Actions';
import { useSelector, useDispatch } from 'react-redux';
// import SchHeadNav from './SchHeadNav';
import SchEditDetailDialog from './SchEditDetailDialog';
// import SchTableHead from './SchTableHead';
import * as comMod from '../../commonModule';
import * as albcm from '../../albCommonModule'
import * as mui from '../common/materialUi';
import {LoadingSpinner, LoadErr, SetUisCookieChkBox} from '../common/commonParts';
// import SimpleModal from '../common/modal.sample';
// import SchDailyDialog from './SchDailyDialog';
import { makeStyles, createMuiTheme } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
// import { common } from '@material-ui/core/colors';
// import AccessTimeIcon from '@material-ui/icons/AccessTime';
// import DriveEtaIcon from '@material-ui/icons/DriveEta';
// import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
// import AddCircleIcon from '@material-ui/icons/AddCircle';
import EachScheduleContent from './SchEachScheduleContent';
// import SchSaveLater from './SchSaveLater';
import { menu, SchInitilizer } from './Sch2';
import { LinksTab } from '../common/commonParts';
import { useLocation, useParams, } from 'react-router-dom';
import SnackMsg from '../common/SnackMsg';
import { OccupancyRate } from './SchHeadNav';
import {SetUsersSchViewCookies} from '../common/StdFormParts'
import { grey, orange, teal, blue, red } from '@material-ui/core/colors';
import { faLess } from '@fortawesome/free-brands-svg-icons';
import { faSleigh } from '@fortawesome/free-solid-svg-icons';
import { RepeatRounded, Satellite } from '@material-ui/icons';
import SchUserDispatcher from './SchUsersDispatcher';

const useStyles = makeStyles({
  userInfo:{
    display:'flex', justifyContent:'center',
    paddingTop: 24, paddingBottom: 15,
    width: '100%',
    '& >div': {margin: '0 8px',}
  },
  occuWrap:{marginTop: 20, width: 'calc(100% - 200px)', marginLeft: 200},
  occuWrapP:{marginTop: 20, width: '100%'}, // パラメータでUIDが与えられている場合
  vDayWrap: {
    cursor:'pointer',
    // '&:nth-of-type(odd) .dateContent':{background: grey[100]},
    '& .mwfClass .dateContent': {background: grey[100]},
    '& .schoolOff .dateContent': {background: '#fff2e0'},
    '& .schoolOff.mwfClass .dateContent': {background: '#ffeaca'},
    '& .off .dateContent': {background: grey[300]},
    '&:hover .dateContent': {background: teal[50]},
    '&:hover .schoolOff.mwfClass .dateContent': {background: teal[50]},
  },
  countRoot: {
    display:'flex', alignItems: 'end', position: 'fixed',
    top: 108, right: 8, background: '#FFFFFF90', zIndex: 999,
    padding: 8,
    '& > div': {paddingLeft: 4, paddingRight: 4},
    '& .count': {fontSize: '1.1rem', color: teal[900], fontWeight: 600},
    '& .absence': {color: blue[800]},
    '& .s': {fontSize: '.7rem', paddingBottom: 1},
    '& .over': {color: red[800]},
  },
  userSelectList: {
    width: 180, height:'calc(100vh - 160px)', overflowY:'scroll',
    position: 'fixed', top: 116,
    '& .oneUser': {
      display: 'flex', margin: '4px 4px', padding:'4px 0px', cursor: 'pointer',
      borderBottom: '1px solid #00000000', // 透明のボーダーを初期値にする
      '& .no': {width: 16, textAlign: 'center', fontSize: '.8rem', paddingTop: 4},
      '& .name': {flex: 1, marginLeft: 12,}

    }
  },
  monthWrapper: {
    marginTop: 16,
    width: 'calc(100% - 200px)', textAlign: 'center',
    marginLeft: 200,
  },
  monthWrapperP: {
    marginTop: 16, width: '100%', textAlign: 'center',
  },
  monthWrapperV: {width:'calc(100% - 200px)', marginLeft: 200 },
  monthWrapperVP: {width: '100%'},
  userNameHeadDisp: {
    // width: 'calc(100% - 200px)', marginLeft: 200,
    padding: 16, paddingTop: 32, textAlign: 'center', position: 'sticky', top:80,
    width: 400, margin: '0 Auto', background: '#FFFFFFCC', zIndex:99,
    '& span': {marginInlineStart: 8, marginInlineEnd: 8}
  }
});

// const UserSlect2 = (props)=>{
//   const {puid, suid, setSuid} = props;
//   const usersOrg = useSelector(state => state.users);
//   const service = useSelector(state => state.service);
//   const classroom = useSelector(state => state.classroom);

//   // パラメータuidが指定されていたらnullを返す
//   if (puid) return null;

//   // サービス内容でユーザーリストを絞り込み
//   const users = usersOrg.filter(e=>(
//     e.service === service &&
//     (classroom === '' || e.classroom === classroom)
//   ));
//   // suidが未指定なら先頭ユーザーに設定
//   if (!suid){
//     setSuid(users[0].uid);
//   };

//   // セレクトのオプションを作成
//   const Options = ()=>{
//     const opt = users.map((e, i)=>{
//       return(
//         <option key={i} value={e.uid}>{e.name + ' ' + e.ageStr}</option>
//       )
//     });
//     return opt;
//   }
//   const selectClass = {
//     // margin: theme.spacing(1),
//     minWidth: 130,
//     marginTop: -46,
//   }
//   const handleChange = (e) =>{
//     const val = e.currentTarget.value; 
//     setSuid(val);
//   }

//   return(<>
//     <FormControl style={selectClass}>
//       <InputLabel >{props.name}</InputLabel>
//       <Select
//         native
//         value={suid}
//         name={'ご利用者選択'}
//         onChange={(e) => handleChange(e)}
//       >
//         <Options />
//       </Select>
//     </FormControl>
//   </>)
// }


// ローカルのステイトでコントロールしていたがstoreにuidを書き込むようにする
// やっぱりLOCALstateへ
const UserSlect = (props)=>{
  const {puid, suid, setSuid} = props;
  const usersOrg = useSelector(state => state.users);
  const service = useSelector(state => state.service);
  const classroom = useSelector(state => state.classroom);

  // パラメータuidが指定されていたらnullを返す
  if (puid) return null;

  // サービス内容でユーザーリストを絞り込み
  const users = usersOrg.filter(e=>(
    e.service === service &&
    (albcm.isClassroom(e, classroom))
  ));
  // suidが未指定なら先頭ユーザーに設定
  if (!suid){
    setSuid(users[0].uid);
  };

  // セレクトのオプションを作成
  const Options = ()=>{
    const opt = users.map((e, i)=>{
      return(
        <option key={i} value={e.uid}>{e.name + ' ' + e.ageStr}</option>
      )
    });
    return opt;
  }
  const selectClass = {
    minWidth: 120,
    marginTop: -46,
  }
  const handleChange = (e) =>{
    const val = e.currentTarget.value; 
    setSuid(val);
  }

  return(<>
    <FormControl style={selectClass}>
      <InputLabel >{props.name}</InputLabel>
      <Select
        native
        value={suid}
        name={'ご利用者選択'}
        onChange={(e) => handleChange(e)}
      >
        <Options />
      </Select>
    </FormControl>
  </>)
}

// ユーザーの選択をセレクトではなく柱でやる
const SideSectionUserSelect = (props)=>{
  const {puid, suid, setSuid} = props;
  const usersOrg = useSelector(state => state.users);
  const service = useSelector(state => state.service);
  const classroom = useSelector(state => state.classroom);
  const classes = useStyles();

  // パラメータuidが指定されていたらnullを返す
  if (puid) return null;

  // サービス内容でユーザーリストを絞り込み
  const users = usersOrg.filter(e=>(
    e.service === service &&
    (albcm.isClassroom(e, classroom))
  ));
  // suidが未指定なら先頭ユーザーに設定
  if (!suid){
    setSuid(users[0].uid);
  };

  const usersElm = users.map((e, i)=>{
    // 最近ユーザーのスタイルとカレントユーザーのスタイルを両方取得して
    // カレントユーザースタイルを優先させる
    let st;
    if (e.uid === suid){
      st = {background: teal[50],borderBottom: '1px solid ' + teal[500]};
    }
    else {
      st = albcm.recentUserStyle(e.uid);
    }
    return (
      <div className='oneUser' onClick={()=>setSuid(e.uid)} style={st}>
        <div className='no'>{i + 1}</div>
        <div className='name'>{e.name}</div>
      </div>
    )
  });

  return(<>
    <div className={classes.userSelectList}>
      {usersElm}
    </div>
  </>)
}

// 2021/09/03 縦型表示を追加してみる
const SevenDaysGrid = (props)=>{
  const classes = useStyles();
  const dateList = useSelector(state=>state.dateList);
  const {
    suid, sch, setSch, dialogOpen, setDialogOpen, setSnack, localFabSch,
    virtical, puid
  } = props;
  // puidが存在するときはパラーメタによるuid指定
  const path = useLocation().pathname;
  // const template = useSelector(state => state.scheduleTemplate);
  const users = useSelector(state => state.users);
  const service = useSelector(state=>state.service);
  const classroom = useSelector(state=>state.classroom);
  const schedule = useSelector(state=>state.schedule);
  const allstate = useSelector(state=>state);
  const template = {[service]:albcm.getTemplate(allstate, sch, suid)};
  // 7曜グリッド作成
  const daysGrid = comMod.makeDaysGrid(dateList);
  // クリックハンドラ
  const clickHandler = (e)=>{
    e.stopPropagation();
    e.preventDefault();

    const did = e.currentTarget.getAttribute('did');
    const UID = 'UID' + suid;
    const date = comMod.convDid(did); // did形式を日付オブジェクトに
    // 引数で受け取ったdatalist全体から該当日付の休日モードを取得
    const holiday = dateList.filter(
      f => f.date.getTime() === date.getTime()
    )[0].holiday;
    const holidayStr = ['weekday', 'schoolOff', 'schoolOff'][holiday];
    // 同じようにserviceを取得
    const thisService = users.filter(f => f.uid === suid)[0].service;
    // 該当スケジュールの取得。見つからなければnull
    let thisSchedule = sch[did];
    
    const thisUser = comMod.getUser(suid, users);
    // MTUの規制
    if (!classroom && albcm.classroomCount(thisUser) > 1){
      const id = new Date().getTime();
      setSnack({
        msg: 'この利用者は複数単位があるので編集できません。', 
        severity: 'warning', id
      });
      return false;
    }
    // なにもしない
    if (localFabSch === 0)  return false;
    
    // スケジュールロックを検出
    const locked = albcm.schLocked(
      schedule, users, thisUser, did, service, classroom
    )
    if (locked){
      const id = new Date().getTime();
      setSnack({msg: '予定はロックされています。', severity: 'warning', id});
      return false;
    }

    // 別単位のスケジュールロック
    if (
      thisSchedule &&
      thisSchedule.classroom && classroom && 
      classroom !== thisSchedule.classroom &&
      localFabSch > 0
    ){
      const id = new Date().getTime();
      setSnack({
        msg: '別単位の予定なので編集できません。', 
        severity: 'warning', id
      });
      return false;
    }
    else{
      setSnack({msg: '', severity: '', id: new Date().getTime()})
    }

    // 追加削除、追加削除モードでスケジュールが存在しない->追加
    if (localFabSch > 0 && !thisSchedule) {
      // テンプレートからディープコピー
      thisSchedule = {...template[thisService][holidayStr]};
      thisSchedule.classroom = classroom;
      const t = {...sch};
      setSch({...t, [did]:thisSchedule});
      albcm.setRecentUser(UID);
    }
    // 追加削除モードでスケジュールが存在する->削除
    else if (localFabSch === 1 && thisSchedule) {
      const t = {...sch};
      delete t[did];
      setSch(t);
      albcm.setRecentUser(UID);
    }
    // 追加修正モードでスケジュールが存在する
    else if (localFabSch === 2 && thisSchedule) {
      const t = {open: true, did, uid: UID, usch: sch};
      setDialogOpen(t);
    }
  }
  // ダイアログオープンstateを監視してLOCALstateを更新
  useEffect(()=>{
    const existUscch = Object.keys(dialogOpen.usch).length;
    if (existUscch){
      setSch(dialogOpen.usch);
    }
  }, [dialogOpen]);

  // ゆーざーがみつからないばあいはnullを返す
  const susers = users.filter(e=>e.service === service);
  const thisUser = (suid, susers);

  if (!Object.keys(thisUser).length)  return null;
  const oneUser = comMod.getUser(suid, thisUser);
  const OneWeek = (props)=>{
    const week = props.week.map((e, i)=>{
      const cls = ['', 'schoolOff', 'off'];// 学校休日休業日を示すクラスリスト
      const wdClass = (e !== '')? cls[e.holiday]:'';
      // 日付オブジェクトをdid形式に変換
      const did = (e !== '') ? comMod.convDid(e.date):''
      // この日のスケジュール
      let thisSchedule;
      // そもそもデータがない
      if (!sch)  thisSchedule = undefined;
      // 該当日のデータがない
      else if (Object.keys(sch).indexOf(did) === -1) 
        thisSchedule = undefined;
      else thisSchedule = sch[did];
      const otherClassroomStyle = 
      (
        thisSchedule &&
        thisSchedule && classroom && 
        thisSchedule.classroom && 
        thisSchedule.classroom !== classroom
      )?{opacity: .3}: {};
    
      return(
        <div className={'day ' } key={i} 
          did = {did}
          onClick = {(e)=>clickHandler(e)}
        >
          {(e !== '') &&
            <div className={'dayLabel ' + wdClass}>
              {e.date.getDate()}
            </div>
          }
          
          <div className='content' style={otherClassroomStyle}>
            <EachScheduleContent thisSchedule={thisSchedule}/>
          </div>
        </div>
      );
    });
    return (<div className='week'>{week}</div>);
  }
  // 縦型表示
  const VrtDisp = (props) => {
    const {puid} = props;
    const classes = useStyles();
    const days = dateList.map((e,i)=>{
      const cls = ['', 'schoolOff', 'off'];// 学校休日休業日を示すクラスリスト
      const wdClass = (e !== '')? ' ' + cls[e.holiday]:'';
      // 日付オブジェクトをdid形式に変換
      const did = (e !== '') ? comMod.convDid(e.date):'';
      // mon wed fri 月水金で有効になるクラス名
      const mwfClass = [1, 3, 5].indexOf(e.date.getDay()) >= 0 
      ? ' mwfClass' : '';
      // この日のスケジュール
      let thisSchedule;
      // そもそもデータがない
      if (!sch)  thisSchedule = undefined;
      // 該当日のデータがない
      else if (Object.keys(sch).indexOf(did) === -1) 
        thisSchedule = undefined;
      else thisSchedule = sch[did];
      return (
        <div className={classes.vDayWrap} 
          key={i} did = {did}
          onClick = {(e)=>clickHandler(e)}
        >
          {/* <div className={'dayLabel ' + wdClass}>
            {e.date.getDate()}
          </div> */}
          <div className={'content ' + wdClass + mwfClass}>
            <EachScheduleContent 
              thisSchedule={thisSchedule} virtical d={e}
            />
          </div>
        </div>
      );
    });
    // パラメータからオープンする場合とそれ以外でクラス名を変更する
    const monthWrapperCls = puid? classes.monthWrapperVP: classes.monthWrapperV;
    return (
      <>
        <div className={monthWrapperCls}>
          <div className={classes.userNameHeadDisp}>
            <span>{oneUser.name} 様</span>
            <span>{oneUser.ageStr}</span>
          </div>
          {days}
        </div>
      </>
    )
  };
  const weeks = daysGrid.map((e, i)=>{
    return (
      <OneWeek week={e} key={i} />
    );
  });
  const GridDisp = (props) => {
    const {puid} = props;
    // パラメータからオープンする場合とそれ以外でクラス名を変更する
    const monthWrapperCls = puid? classes.monthWrapperP: classes.monthWrapper;
    return(
      <div className={'monthWrapper ' + monthWrapperCls}>
        <div className={classes.userNameHeadDisp}>
          <span>{oneUser.name} 様</span>
          <span>{oneUser.ageStr}</span>
        </div>
        <div className="month">
          <div className='week'>
            <div className='day weekLabel'>日</div>
            <div className='day weekLabel'>月</div>
            <div className='day weekLabel'>火</div>
            <div className='day weekLabel'>水</div>
            <div className='day weekLabel'>木</div>
            <div className='day weekLabel'>金</div>
            <div className='day weekLabel'>土</div>
          </div>
          {weeks}
        </div>
      </div>
    );
  };
  return (<>
    {virtical === false && <GridDisp puid={puid}/>}
    {virtical === true && <VrtDisp puid={puid}/>}
  </>);
}

const CountDisp = (props) => {
  const classes = useStyles();
  const {sch, suid} = props;
  let count = 0;
  let absence = 0;
  const users = useSelector(state=>state.users);
  const thisUser = comMod.getUser(suid, users);
  const volume = parseInt(thisUser.volume);
  Object.keys(sch? sch: {}).filter(e=>/^D2[0-9]{7}/.test(e)).forEach(e=>{
    if (!sch[e].absence) count++;
    else absence++;
  });
  console.log(count, absence, volume, 'countDisp');
  const overClass = count > volume? 'over': '';
  return (
    <div className={classes.countRoot}>
      <div className='s'>利用</div>
      <div className={'count ' + overClass}>{count}</div>
      <div className='s'>欠席</div>
      <div className='absence'>{absence}</div>
      <div className='s'>/</div>
      <div className='n'>{volume}</div>
    </div>
  )
}

const MainSchByUsers = (props)=>{
  const classes = useStyles();
  const users = useSelector(state => state.users);
  const service = useSelector(state => state.service);
  const classroom = useSelector(state => state.classroom);
  const schedule = useSelector(state => state.schedule);
  const scheduleLocked = schedule.locked;
  const serviceItems = useSelector(state => state.serviceItems);
  const stdDate = useSelector(state => state.stdDate);
  // const {suid, setSuid, } = props;
  const hid = useSelector(state => state.hid);
  const bid = useSelector(state => state.bid);
  const dispatch = useDispatch();
  // ダイアログ制御用
  const [dialogOpen, setDialogOpen] = useState({
    open: false, uid: '', did: '' , usch: {}
  });

  // サービスが未設定なら設定する
  if (!service) {
    dispatch(Actions.changeService(serviceItems[0]));
  }
  // 対象となるユーザーのリスト
  const fusers = albcm.getFilteredUsers(users, service, classroom);
  // パラメータからuidを取得トライ
  const puid = useParams().p;
  // uid をlocal state化
  const [suid, setSuid] = useState(puid? puid: '');
  // ユーザーごとのスケジュール定義 初期状態であることを確認するためのフラグ格納
  const [sch, setSch] = useState({init: true});
  const [snack, setSnack] = useState({msg: '', severity: '', id: 0});
  const [res, setRes] = useState(null);
  const [localFabSch, setLocalFabSch] = useState(0);
  const [userInfo, setUserInfo] = useState({});
  // 縦型表示にするかどうか SetUsersSchViewCookiesで設定される
  const [virtical, setVirtical] = useState(
    comMod.getUisCookie(comMod.uisCookiePos.usersSchViewVirtical) !== '0'
  );
  const favSchProps = {localFabSch, setLocalFabSch};
  const nodeId = 'nodeX765' + service + classroom;
  const [allSch, setAllSch] = useState(()=>{
    const t = {};
    Object.keys(schedule).forEach(e=>{
      if (!comMod.getUser(e, fusers)) return false;
      t[e] = schedule[e];
    });
    return t;
  });
  // suidを保持するよ
  const controleMode = useSelector(state=>state.controleMode);
  // useRef使ってみるよ
  const firstRender = useRef(false);
  // ユーザーごとのスケジュールを設定
  useEffect(()=>{
    let isMounted = true;
    if (suid && firstRender && isMounted){
      setSch(allSch['UID' + suid]);
      setUserInfo(comMod.getUser(suid, users));
      // スケジュールデータが最初に読み込まれたフラグ
      firstRender.current = true;
    }
    return ()=>{
      isMounted = false;
    }

  }, [suid]);


  // -------------------------------
  // 作り直すよ
  // -------------------------------
  useEffect(()=>{
    const uiLen = Object.keys(userInfo).length;
    const schLen = (sch)? Object.keys(sch).length: 0;
    const sendItem = async (v) =>{
      const sendPrms = {
        uid: 'UID' + suid, hid, bid, date: stdDate, schedule: sch 
      }
      console.log(sch, 'send sch', scheduleLocked, 'scheduleLocked');
      if (!scheduleLocked){
        await albcm.sendUsersSchedule(sendPrms, setRes, setSnack, userInfo.name);
      }
    }
    const dispatchItem = async (v) =>{
      const t = {...schedule};
      const s = {...allSch};
      Object.keys(s).forEach(e=>{
        t[e] = s[e]
      });
      t['UID' + suid] = sch;
      if (sch !== undefined){
        dispatch(Actions.setStore({schedule: t}));  
      }
    }
    // なんでここでschLenを見ているのかわからんぞ 2022/07/21
    // if (!firstRender.current && schLen > 1){
    if (!firstRender.current){
      sendItem();
    }
    if (firstRender.current && uiLen){
      firstRender.current = false;
    }
    const s = {...allSch};
    s['UID' + suid] = sch;
    setAllSch(s);
    return () => {
      console.log('unmounted');
      setTimeout(()=>{
        const closed = !document.querySelector('#' + nodeId);
        if (Object.keys(sch? sch: {}).length > 1 && closed){
          dispatchItem();
        }
      }, 100)
    }
  }, [sch, ])

  const susers = users.filter(e=>e.service === service);
  const pUser = comMod.getUser(puid, susers); // パラメータで指定されたユーザー
  const pUserExist = Object.keys(pUser).length;
  const Uinfo = () => {
    const noUserstyle = {paddingTop: 60, textAlign:'center'};
    if (!puid){
      return null;
    }
    return(<>
      {pUserExist > 1 && <>
        <div className={classes.userInfo}>
          <div>{pUser.name} 様</div>
          <div>{pUser.ageStr}</div>
          <div>{pUser.belongs1}</div>
        </div>
      </>}
      
      {pUserExist === 0 && <>
        <div style={noUserstyle}>
          存在しないユーザーが指定されました。
        </div>
      </>}
    </>)
  }
  const sdPrms = {
    suid, sch, setSch, dialogOpen, setDialogOpen, setSnack, localFabSch,
    virtical, puid
  };
  const occuWrapCalss = puid? classes.occuWrapP: classes.occuWrap;  
  return(<>
    <LinksTab menu={menu} />
    <div className="AppPage schByUsers">
      <div className={occuWrapCalss}>
        <OccupancyRate displayMode='wide' localSch={{['UID' + suid]:sch}} />
      </div>
      <SideSectionUserSelect puid={puid} suid={suid} setSuid={setSuid} />
      <CountDisp {...sdPrms} />
      <SevenDaysGrid {...sdPrms} />
      <mui.FabSchedule {...favSchProps} />
      <SchEditDetailDialog 
        stateOpen={dialogOpen} setStateOpen={setDialogOpen} setSch={setSch}
      />
      <SnackMsg {...snack} />
      <div style={{marginLeft:200, marginTop: 16, textAlign: 'center', }}>
        {/* <SetUsersSchViewCookies setVirtical={setVirtical}/> */}
        <SetUisCookieChkBox 
          setValue={setVirtical} p={comMod.uisCookiePos.usersSchViewVirtical}
          label='縦型表示にする'
        />
      </div>

    </div>
    <div id={nodeId}></div>
    <SchUserDispatcher/>
    <SchInitilizer/>
  </>)
}

// const ErrSchByUsers = ()=>{
//   return(<div>error occured.</div>)
// }

const SchByUsers2 = ()=>{
  // const userFtc = useSelector(state => state.userFtc);
  // const fetchCalenderStatus = useSelector(state => state.fetchCalenderStatus);
  // // fetch状態の取得
  // const done = (
  //   userFtc.done && fetchCalenderStatus.done
  // );
  // const errorOccured = (
  //   userFtc.err || fetchCalenderStatus.err
  // );
  // const loading = (
  //   userFtc.loading || fetchCalenderStatus.loading
  // );
  const dispatch = useDispatch();
  const allstate = useSelector(state=>state);
  const loadingStatus = comMod.getLodingStatus(allstate);
  // ------ 下位モジュールより
  // パラメータからuidを取得トライ
  const puid = useParams().p;
  // uid をlocal state化
  // const [suid, setSuid] = useState(puid? puid: '');
  // 全体のスケジュールをローカルstate化
  // const [allSch, setAllSch] = useState(allstate.schedule);
  // const props = {suid, setSuid, allSch, setAllSch, puid};
  const normalId = 'nomal-schbyuser2';
  const notNormalId = 'not-nomal-schbyuser2';

  if (loadingStatus.loaded){
    return(<>
      <MainSchByUsers />
      <div id={normalId}></div>
    </>)
  }
  else if (loadingStatus.error){
    return (<>
      <LoadErr loadStatus={loadingStatus} errorId={'E4941'} />
      <div id={notNormalId}></div>
    </>)
  }
  else{
    return(<>
     <LoadingSpinner/>
     <div id={notNormalId}></div>
    </>)
  }
  // if (done) return (<MainSchByUsers />);
  // else if (loading) return (<LoadingSpinner />);
  // else if (errorOccured) return (<ErrSchByUsers />);
  // else return null;
}
export default SchByUsers2;